import {
  api,
  AppSettingsHtmlDirectionAction,
  AppSettingsLanguageAction,
  AppSettingsStateViewModel,
} from 'alg-ecom-frontend-core';
import React, { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import {
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import { Dispatch } from 'redux';
import { FullPageLoader } from '../../components/loader';
import { RouteKeys } from './route-keys';

const RedirectIfAuthenticatedRoute = lazy(
  () => import('./RedirectIfAuthenticatedRoute')
);
const UnAuthenticateRoute = lazy(() => import('./UnAuthenticatedRoute'));
const AuthenticateRoute = lazy(() => import('./AuthenticateRoute'));
const Home = lazy(() => import('../home'));
const NotFound = lazy(() => import('../notfound'));
const TrimLevel = lazy(() => import('../trim-level'));
const TrimLevelYear = lazy(() => import('../trim-level-year/TrimLevelYear'));
const EditionVarient = lazy(() => import('../edition-variant'));
const BuildVehicle = lazy(() => import('../build-vehicle'));
const Landing = lazy(() => import('../landing'));
const PaymentSelection = lazy(() => import('../payment/PayNow'));
const PaymentSuccess = lazy(() => import('../payment/PaymentSuccess'));
const AuthPage = lazy(() => import('../auth/AuthPage'));
const MyAccount = lazy(() => import('../dashboard'));
const ProductDetail = lazy(() => import('../product-detail/ProductDetail'));
const NewsListing = lazy(() => import('../news/NewsListing'));
const NewsDetail = lazy(() => import('../news/NewsDetail'));
const Contact = lazy(() => import('../cms/contact'));
const Owners = lazy(() => import('../cms/owners'));
const Specs = lazy(() => import('../cms/specs'));
const Insurance = lazy(() => import('../cms/insurance'));
const Finance = lazy(() => import('../cms/finance'));
const FinanceOpt = lazy(() => import('../cms/financeOpt'));
const PrivacyPolicy = lazy(() => import('../cms/privacypolicy'));
const Disclaimer = lazy(() => import('../cms/disclaimer'));
const AboutUs = lazy(() => import('../cms/about'));
const Service = lazy(() => import('../cms/service'));
const Offer = lazy(() => import('../offer'));
const CampaignOffer = lazy(() => import('../campaign-offers'));
const OfferThankYou = lazy(() => import('../offer/OfferThankYou'));
const Terms = lazy(() => import('../cms/terms'));
const WelcomeForm = lazy(() => import('../cms/welcomeform'));
const VirtualTour = lazy(() => import('../cms/VirtualTour'));
const TestDriveCampaign = lazy(
  () => import('../cms/TestDriveCampaign/TestDriveCampaign')
);
const PaymentLink = lazy(() => import('../payment/PaymentLink'));

const PaymentLinkSuccess = lazy(() => import('../payment/PaymentLinkSuccess'));
const Adas = lazy(() => import('../adas/'));
const ForgotPassowrd = lazy(
  () => import('../auth/forgot-password/ForgotPasswordPage')
);
const TestDrivePage = lazy(
  () => import('../quick-form-pages/TestDrive/TestDrivePage')
);
const RequestCallbackPage = lazy(
  () => import('../quick-form-pages/RequestCallBack/RequestCallbackPage')
);
const Campaign = lazy(() => import('../campaign'));
const DiscountApproval = lazy(() => import('../discount-approval/index'));
const ApprovalStatus = lazy(
  () => import('../discount-approval/ApprovalStatus')
);

const CustomerPaymentLink = lazy(
  () => import('../payment/PaymentLinkCustomer')
);

const CustomerPaymentLinkSuccess = lazy(
  () => import('../payment/PaymentLinkSuccessCustomer')
);

interface CustomProps {
  appSettingsState: AppSettingsStateViewModel;
}
const SubRoutes: React.FunctionComponent<CustomProps> = (props) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { lang } = useParams<{
    lang: string;
  }>();
  React.useEffect(() => {
    // console.log('props poli', history.location);
    // const query = new URLSearchParams(history?.location?.search);
    // const qlang = query.get('ln');
    if (lang === 'ar' || lang === 'en') {
      const data = props?.appSettingsState?.data?.languagesList.find(
        (item) => item.languageLcidstring === lang
      );

      const language =
        props.appSettingsState.htmlDirection === 'ltr' ? 'en' : 'ar';
      const direction = language === 'en' ? 'ltr' : 'rtl';
      if (data) {
        const qdirection = data.languageDirection;
        if (qdirection !== direction) {
          handleLanguage(data.languageLcidstring);
        } else {
          i18n.changeLanguage(language);
          document
            .getElementsByTagName('html')[0]
            .setAttribute('dir', language === 'en' ? 'ltr' : 'rtl');
        }
      } else {
        i18n.changeLanguage(language);
        document
          .getElementsByTagName('html')[0]
          .setAttribute('dir', language === 'en' ? 'ltr' : 'rtl');
      }
    } else {
      handleLanguage('ar');
      history.replace({
        pathname: path.replace(':lang', 'ar'),
        // search: queryParams.toString(),
      });
    }
  }, [props.appSettingsState.htmlDirection]);

  const handleLanguage = (ln: string) => {
    if (
      props?.appSettingsState?.data &&
      props?.appSettingsState?.data?.languagesList?.length > 0
    ) {
      const data = props?.appSettingsState?.data?.languagesList.find(
        (item) => item.languageLcidstring === ln
      );
      if (data) {
        api.setLanguageID(data.languageID);
        dispatch(AppSettingsLanguageAction(data.languageID));
        dispatch(AppSettingsHtmlDirectionAction(ln === 'en' ? 'ltr' : 'rtl'));
        // const queryParams = new URLSearchParams(location.search);

        // if (queryParams.has('ln') && isRemoveQuery === true) {
        //   queryParams.delete('ln');
        //   history.replace({
        //     search: queryParams.toString(),
        //   });
        // }
        // if (isRemoveQuery === false) {
        //   window.location.reload();
        // }
      }
    }
  };
  return (
    <Suspense fallback={<FullPageLoader text={'Loading...'} />}>
      <Switch>
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Build}`}
          component={Home}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.TrimLEvel}`}
          component={TrimLevel}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.TrimLevelYear}`}
          component={TrimLevelYear}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.EditionVariant}`}
          component={EditionVarient}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.PayNow}`}
          component={PaymentSelection}
          showFooter={false}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.PaymentCallback}`}
          component={PaymentSuccess}
          showFooter={false}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.BuildVehicle}`}
          component={BuildVehicle}
          showFooter={false}
          fullHeader={true}
          outerClass={'build-detail-page'}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Home}`}
          component={Landing}
          showFooter={true}
        />
        <RedirectIfAuthenticatedRoute
          exact
          path={`${path}${RouteKeys.Auth}`}
          component={AuthPage}
          // showFooter={false}
          // avoidHeader
        />
        <RedirectIfAuthenticatedRoute
          exact
          path={`${path}${RouteKeys.ForgotPassword}`}
          component={ForgotPassowrd}
          // showFooter={false}
          // avoidHeader
        />
        <AuthenticateRoute
          exact
          path={`${path}${RouteKeys.MyAccount}`}
          component={MyAccount}
          showFooter={false}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Adas}`}
          component={Adas}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.ProductDetail}`}
          component={ProductDetail}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.News}`}
          component={NewsListing}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.NewsDetail}`}
          component={NewsDetail}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Contact}`}
          component={Contact}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Owners}`}
          component={Owners}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Specs}`}
          component={Specs}
          showFooter={true}
        />

        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Insurance}`}
          component={Insurance}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Finance}`}
          component={Finance}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.FinanceOpt}`}
          component={FinanceOpt}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.PrivacyPolicy}`}
          component={PrivacyPolicy}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Terms}`}
          component={Terms}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Disclaimer}`}
          component={Disclaimer}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.AboutUs}`}
          component={AboutUs}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Service}`}
          component={Service}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.Offer}`}
          component={Offer}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.CampaignOffers}`}
          component={CampaignOffer}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.OfferThankYou}`}
          component={OfferThankYou}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.QuickAccessThankYou}`}
          component={OfferThankYou}
          showFooter={true}
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.WelcomeForm}`}
          component={WelcomeForm}
          showFooter={true}
        />

        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.VirtualShowroom}`}
          component={VirtualTour}
          showFooter={true}
        />
        <Route
          exact
          path={`${path}${RouteKeys.TestDriveCampaign}`}
          component={TestDriveCampaign}
        />

        <UnAuthenticateRoute
          path={`${path}${RouteKeys.PaymentLink}/ID/:id/configID/:configID/amount/:amount`}
          component={PaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.PaymentLinkSuccess}`}
          component={PaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.quickFormTestDrive}`}
          component={TestDrivePage}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.quickFormRequestCallback}`}
          component={RequestCallbackPage}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.campaignEnquire}`}
          component={Campaign}
          showFooter={true}
        />

        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.DiscountApproval}/token/:token`}
          component={DiscountApproval}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.ApprovalStatus}/:status`}
          component={ApprovalStatus}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.DiscountApproval}/token/:token`}
          component={DiscountApproval}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.ApprovalStatus}/:status`}
          component={ApprovalStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          path={`${path}${RouteKeys.PaymentLink}/ID/:id/customerId/:customerId/amount/:amount`}
          component={CustomerPaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`${path}${RouteKeys.CustomerPaymentLinkSuccess}`}
          component={CustomerPaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />

        {/* <Route exact path={RouteKeys.Home} component={Home} /> */}
        <Route exact path={RouteKeys.NotFound} component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = (state: any) => ({
  appSettingsState: state.appSettingsState,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  // redirectSave: (to: string) => {
  //   dispatch(authUserActions.redirectSave(to));
  // },
});

export default connect(mapStateToProps, mapDispatchToProps)(SubRoutes);
